import React from 'react';
// Eager on purpose. The preview chunks carry this stylesheet too, but a
// placeholder has to be the right size before any of them arrives.
import './PdfViewer.css';

/**
 * Empty boxes the shape of each PDF view's first frame, for Suspense fallbacks
 * (ADR 0067). A fallback smaller than what replaces it moves everything under
 * it when the chunk lands, and Chrome counts that: the chart pages' one-line
 * "Loading preview" gave way to a full page and pushed the footer off screen,
 * a measured layout shift of 0.58.
 *
 * These import no PDF code, so they are safe on the eager side of the bundle
 * boundary (bundleBoundary.test.js).
 */

/** The inline frame's box, as PdfFrame draws it before the first PDF exists. */
export function PdfFramePlaceholder({ frameClassName }: { frameClassName: string }) {
    return (
        <div className="pdfFrame">
            <div className={frameClassName + ' pdfFrameEmpty'} aria-hidden="true" />
        </div>
    );
}

/** The mobile canvas preview's box, as PdfCanvasPreview draws it unpainted. */
export function PdfCanvasPlaceholder() {
    return (
        <div className="pdfCanvasPreview">
            <div className="pdfCanvasPreviewCanvas pdfCanvasPreviewCanvas--empty" aria-hidden="true" />
        </div>
    );
}
